import React, { useState } from 'react'
import './AppFormItem.less'
import { Icon } from 'antd'

interface AppSearchItemProps {
  value?: string
  text?: string
  placeholder?: string
  onSearch?: (value: string) => void
  onChange?: (value: string) => void
}

export const AppSearchItem = (props: AppSearchItemProps) => {
  const [focus, setFocus] = useState(false)

  const onChange = () => {
    props.onChange && props.onChange(refInput.current.value);
    setFocus(false)
  }

  const onSearch = () => {
    props.onChange && props.onChange(refInput.current.value);
    props.onSearch && props.onSearch(refInput.current.value);
  }

  const refInput = React.createRef<HTMLInputElement>()
  return (<span className="app-form-item-input" style={{ borderWidth: '0px', width: '100%' }}>
    <div className={`mc-spinner ${focus ? 'mc-spinner-focus' : ''}`}>
      <div className="input input-group input-group-append">
        <div style={{ display: 'inline-table', width: '100%' }}>
          <div className="input-inner-warp">
            <input
              ref={refInput}
              className="input-inner input-inner-icon"
              placeholder={props.placeholder || ''}
              defaultValue={props.value}
              onBlur={onChange}
              onFocus={e => setFocus(true)}
            />
          </div>
          <div className="input-icon-div">
            <Icon type="plus" />
          </div>
        </div>
      </div>
    </div>
  </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppSearchItem.tsx